import { EventEmitter } from '@angular/core';
import { Store } from '@ngrx/store';
import { setFundChartDateSelection } from 'ChartApp/ts/features/fund-chart-page-shared/state/reducers/date-selection/date-selection.actions';
import { setFundChartEndDate } from 'ChartApp/ts/features/fund-chart-page-shared/state/reducers/end-date/end-date.actions';
import { setFundChartStartDate } from 'ChartApp/ts/features/fund-chart-page-shared/state/reducers/start-date/start-date.actions';
import { setFundChartZoom } from 'ChartApp/ts/features/fund-chart-page-shared/state/reducers/zoom/zoom.actions';
import { getChartEndDate } from 'ChartApp/ts/features/fund-chart-page-shared/state/reducers/end-date/end-date.selectors';
import { getChartStartDate } from 'ChartApp/ts/features/fund-chart-page-shared/state/reducers/start-date/start-date.selectors';
import { ChartDateZoom } from 'ChartApp/ts/enums/chart-common.enum';
import { formatDateString } from 'Core/redesign/utils/date';
import * as i0 from "@angular/core";
import * as i1 from "@ngrx/store";
import * as i2 from "@angular/common";
import * as i3 from "../../../../../../../../../ycharts/static/ts/features/components/date-controls/date-range/date-range.component";
import * as i4 from "../../../../../../../../../ycharts/static/ts/features/components/date-controls/full-year-date-range/full-year-date-range.component";
import * as i5 from "../../../fundamental-chart/components/fund-chart-date-zoom/fund-chart-date-zoom.component";
import * as i6 from "../../../../../../../../../ycharts/static/ts/features/directives/icon/icon.directive";
import * as i7 from "../../../../../../../../../ycharts/static/ts/features/components/dropdowns/single-select-dropdown/single-select-dropdown.component";
import * as i8 from "../../../../../../../../../ycharts/static/ts/features/directives/popovers/tooltip/tooltip.directive";
const _c0 = () => ({ list: "user-select-none" });
const _c1 = a0 => ({ "highlight-blue": a0 });
const _c2 = () => ({ button: "form-label dropdown-toggle", dropdownMenu: "dropdown-menu" });
const _c3 = (a0, a1) => ({ startDate: a0, endDate: a1 });
function FundChartViewControlsComponent_Conditional_6_Template(rf, ctx) { if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 6)(1, "button", 7);
    i0.ɵɵlistener("click", function FundChartViewControlsComponent_Conditional_6_Template_button_click_1_listener() { i0.ɵɵrestoreView(_r1); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.toggleFS()); });
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(2, "svg", 8);
    i0.ɵɵelementEnd();
    i0.ɵɵnamespaceHTML();
    i0.ɵɵelementStart(3, "button", 7);
    i0.ɵɵlistener("click", function FundChartViewControlsComponent_Conditional_6_Template_button_click_3_listener() { i0.ɵɵrestoreView(_r1); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.toggleAnnotation()); });
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(4, "svg", 9);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngClass", ctx_r1.isFullScreen ? "btn-primary" : "btn-secondary")("tooltipTitle", ctx_r1.isFullScreen ? "Collapse Fullscreen" : "Expand Fullscreen")("tooltipPlacement", "left");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngClass", ctx_r1.annotationsHidden ? "btn-primary" : "btn-secondary")("tooltipTitle", ctx_r1.annotationsHidden ? "Show Annotations" : "Hide Annotations")("tooltipPlacement", "left");
} }
export class FundChartViewControlsComponent {
    constructor(store) {
        this.store = store;
        this.annotationsHidden = false;
        this.isFullScreen = false;
        this.showViewToggles = true;
        this.isFullScreenChange = new EventEmitter();
        this.annotationsHiddenChange = new EventEmitter();
        this.dateSelection = '';
        this.currentYear = new Date().getFullYear();
        this.endDate = null;
        this.startDate = null;
        this.startYear = null;
        this.endYear = null;
        this.dateRangeTypeDropdownIsOpen = false;
        this.dropdownOptions = {
            title: {
                label: '',
            },
            list: [
                {
                    label: 'DATE RANGE',
                    value: 'range',
                },
                {
                    label: 'FULL YEAR',
                    value: 'year',
                },
            ],
        };
        this.zoom = ChartDateZoom.CHART_ZOOM_ONE_YEAR;
        this.mapStateToComponent = (state) => {
            const { fundChart } = state;
            this.zoom = fundChart.zoom;
            this.dateSelection = fundChart.dateSelection;
            this.startDate = getChartStartDate(state);
            this.endDate = getChartEndDate(state);
            // Check if the selected date range is in full years, meaning it begins and ends on the last day of a year
            if (this.startDate && this.endDate) {
                const lastMonth = 11;
                const lastDay = 31;
                const selectedDateRangeIsFullYear = this.startDate.getFullYear() !== this.endDate.getFullYear() &&
                    this.startDate.getMonth() === lastMonth &&
                    this.startDate.getDate() === lastDay &&
                    this.endDate.getMonth() === lastMonth &&
                    this.endDate.getDate() === lastDay;
                this.startYear = selectedDateRangeIsFullYear ? this.startDate.getFullYear() + 1 : null;
                if (selectedDateRangeIsFullYear && this.startYear !== this.endDate.getFullYear()) {
                    this.endYear = this.endDate.getFullYear();
                }
                else {
                    this.endYear = null;
                }
            }
        };
        this.storeSubscription = this.store.select('reducers').subscribe(this.mapStateToComponent);
    }
    ngOnDestroy() {
        this.storeSubscription.unsubscribe();
    }
    zoomChangeHandler(zoom) {
        this.store.dispatch(setFundChartZoom({ zoom: zoom.value }));
        // Wipe out start / end date if custom zoom
        if (zoom.value !== '') {
            this.store.dispatch(setFundChartStartDate({ date: '' }));
            this.store.dispatch(setFundChartEndDate({ date: '' }));
        }
    }
    startDateChangeHandler(startDate) {
        this.store.dispatch(setFundChartStartDate({ date: startDate }));
        this.store.dispatch(setFundChartZoom({ zoom: '' }));
    }
    endDateChangeHandler(endDate) {
        this.store.dispatch(setFundChartEndDate({ date: endDate }));
        this.store.dispatch(setFundChartZoom({ zoom: '' }));
    }
    selectStartDate(newDateRangeObj) {
        const startDate = newDateRangeObj.startDate ? formatDateString(newDateRangeObj.startDate) : null;
        this.startDateChangeHandler(startDate);
    }
    selectEndDate(newDateRangeObj) {
        const endDate = newDateRangeObj.endDate ? formatDateString(newDateRangeObj.endDate) : null;
        this.endDateChangeHandler(endDate);
    }
    changeYearSelection(newDateRangeObj) {
        if (newDateRangeObj.startDate?.date) {
            const startDate = formatDateString(newDateRangeObj.startDate.date);
            this.startDateChangeHandler(startDate);
        }
        if (newDateRangeObj.endDate?.date) {
            const endDate = formatDateString(newDateRangeObj.endDate.date);
            this.endDateChangeHandler(endDate);
        }
    }
    dateRangeTypeHandler(value) {
        this.store.dispatch(setFundChartDateSelection({ selection: value }));
    }
    dateRangeDropdownCloseHandler() {
        this.dateRangeTypeDropdownIsOpen = false;
    }
    dateRangeDropdownOpenHandler() {
        this.dateRangeTypeDropdownIsOpen = true;
    }
    toggleAnnotation() {
        this.annotationsHidden = !this.annotationsHidden;
        this.annotationsHiddenChange.emit(this.annotationsHidden);
    }
    toggleFS() {
        this.isFullScreen = !this.isFullScreen;
        this.isFullScreenChange.emit(this.isFullScreen);
    }
}
FundChartViewControlsComponent.ɵfac = function FundChartViewControlsComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || FundChartViewControlsComponent)(i0.ɵɵdirectiveInject(i1.Store)); };
FundChartViewControlsComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: FundChartViewControlsComponent, selectors: [["ycn-fund-chart-view-controls"]], inputs: { annotationsHidden: "annotationsHidden", isFullScreen: "isFullScreen", showViewToggles: "showViewToggles" }, outputs: { isFullScreenChange: "isFullScreenChange", annotationsHiddenChange: "annotationsHiddenChange" }, standalone: false, decls: 7, vars: 22, consts: [[1, "col-i-md-4", "col-i-lg-5", "chart-control-cover", 3, "selectZoomOptionHandler", "zoom", "customCssClasses"], [1, "col", "form-inline"], [1, "data-range-cover", "data-range-cover-rich", "form-inline", "input-group"], [1, "form-inline", "dropdown", 3, "closeHandler", "openHandler", "changeHandler", "customCssClasses", "config", "selectedValue"], [1, "inputs-wrap", 3, "startDateChangeHandler", "endDateChangeHandler", "hidden", "startYear", "endYear", "selectedDateRange"], [1, "inputs-wrap", "dropdown", 3, "dateRangeHandler", "hidden", "startYear", "endYear"], [1, "form-inline"], ["ycnTooltip", "", 1, "btn", 3, "click", "ngClass", "tooltipTitle", "tooltipPlacement"], ["ycnIcon", "", "name", "icon-expand-full"], ["ycnIcon", "", "name", "icon-password-no-show"]], template: function FundChartViewControlsComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "ycn-fund-chart-date-zoom", 0);
        i0.ɵɵlistener("selectZoomOptionHandler", function FundChartViewControlsComponent_Template_ycn_fund_chart_date_zoom_selectZoomOptionHandler_0_listener($event) { return ctx.zoomChangeHandler($event); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(1, "div", 1)(2, "div", 2)(3, "ycn-single-select-dropdown", 3);
        i0.ɵɵlistener("closeHandler", function FundChartViewControlsComponent_Template_ycn_single_select_dropdown_closeHandler_3_listener() { return ctx.dateRangeDropdownCloseHandler(); })("openHandler", function FundChartViewControlsComponent_Template_ycn_single_select_dropdown_openHandler_3_listener() { return ctx.dateRangeDropdownOpenHandler(); })("changeHandler", function FundChartViewControlsComponent_Template_ycn_single_select_dropdown_changeHandler_3_listener($event) { return ctx.dateRangeTypeHandler($event); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(4, "ycn-date-range", 4);
        i0.ɵɵlistener("startDateChangeHandler", function FundChartViewControlsComponent_Template_ycn_date_range_startDateChangeHandler_4_listener($event) { return ctx.selectStartDate($event); })("endDateChangeHandler", function FundChartViewControlsComponent_Template_ycn_date_range_endDateChangeHandler_4_listener($event) { return ctx.selectEndDate($event); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(5, "ycn-full-year-date-range", 5);
        i0.ɵɵlistener("dateRangeHandler", function FundChartViewControlsComponent_Template_ycn_full_year_date_range_dateRangeHandler_5_listener($event) { return ctx.changeYearSelection($event); });
        i0.ɵɵelementEnd()();
        i0.ɵɵconditionalCreate(6, FundChartViewControlsComponent_Conditional_6_Template, 5, 6, "div", 6);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵproperty("zoom", ctx.zoom)("customCssClasses", i0.ɵɵpureFunction0(15, _c0));
        i0.ɵɵadvance(2);
        i0.ɵɵclassMap(i0.ɵɵpureFunction1(16, _c1, ctx.dateRangeTypeDropdownIsOpen));
        i0.ɵɵadvance();
        i0.ɵɵproperty("customCssClasses", i0.ɵɵpureFunction0(18, _c2))("config", ctx.dropdownOptions)("selectedValue", ctx.dateSelection);
        i0.ɵɵadvance();
        i0.ɵɵproperty("hidden", ctx.dateSelection === "year")("startYear", 1890)("endYear", ctx.currentYear)("selectedDateRange", i0.ɵɵpureFunction2(19, _c3, ctx.startDate, ctx.endDate));
        i0.ɵɵadvance();
        i0.ɵɵproperty("hidden", ctx.dateSelection === "range")("startYear", ctx.zoom === "" ? ctx.startYear : null)("endYear", ctx.zoom === "" ? ctx.endYear : null);
        i0.ɵɵadvance();
        i0.ɵɵconditional(ctx.showViewToggles ? 6 : -1);
    } }, dependencies: [i2.NgClass, i3.DateRangeComponent, i4.FullYearDateRangeComponent, i5.FundChartDateZoomComponent, i6.IconDirective, i7.SingleSelectDropdownComponent, i8.TooltipDirective], encapsulation: 2 });
